import React from "react";
import Icon from "../icon/Icon";
import { UncontrolledTooltip } from "reactstrap";
import { KeyRound } from "lucide-react";

const TooltipComponent = ({
  iconClass,
  icon,
  id,
  direction,
  text,
  containerClassName,
  customIcon,
  ...props
}) => {
  return (
    <React.Fragment>
      {props.tag
        ? !customIcon && (
            <props.tag className={containerClassName} id={id} {...props}>
              {" "}
              <Icon
                className={`${iconClass ? iconClass : ""}`}
                name={icon}
              ></Icon>
            </props.tag>
          )
        : !customIcon && (
            <Icon
              className={`${iconClass ? iconClass : ""}`}
              name={icon}
              id={id}
            ></Icon>
          )}

      {customIcon ? <KeyRound /> : null}
      <UncontrolledTooltip autohide={false} placement={direction} target={id}>
        {text}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};
export default TooltipComponent;
